import api from "./index";

export async function getEntities(params) {
  return api.get(`/entities`, { params: params });
}

export async function createEntity(body) {
  return api.post(`/entities`, body);
}

export async function updateEntity(id, body) {
  return api.put(`/entities/${id}`, body);
}

export async function getEntity(id) {
  return api.get(`/entities/${id}`);
}

export async function deleteEntity(id) {
  return api.delete(`/entities/${id}`);
}

export async function addEntityPerson(entityID, body) {
  return api.post(`/entities/${entityID}/people/bulk/add`, body);
}

export async function deleteEntityPerson(entityID, body) {
  return api.post(`/entities/${entityID}/people/bulk/delete`, body);
}

export async function updateEntityPerson(entityID, personID, body) {
  return api.put(`/entities/${entityID}/people/${personID}`, body);
}

export async function getEntitiesMetadada(params) {
  return api.get(`/entities/metadata`, { params });
}

export async function getEntitiesSettings(params) {
  return api.get(`/entities/settings`, { params });
}

export async function getEntityHistory(entityID, params) {
  return api.get(`/entities/history`, { params: { entityID, ...params } });
}
